import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import { EVIDENCE_PREFIX } from '../../../utils/constants/task';
import { TASK_FIELDS } from '../../../utils/formFields/task';
import SubForm from '../../../components/Forms/Fields/SubForm';

const useStyle = makeStyles(() => ({
  cell: {
    width: '44%',
  },
}));

const EmbeddedEvidenceForm = ({
  value,
  item,
  onChange,
  patrolEvidenceOptions = false,
}) => {
  const classes = useStyle();

  const target = value ? value[`${EVIDENCE_PREFIX}${item.seqNumber}`] : null;

  const { formHeader, ...field } = TASK_FIELDS.evidenceRequired(
    patrolEvidenceOptions,
  );
  return (
    <SubForm
      {...field}
      subFormHeader={formHeader}
      value={target ? target.value : []}
      cellClassName={classes.cell}
      onChange={value => {
        onChange({
          value,
          seqNumber: item.seqNumber,
          point: item,
        });
      }}
    />
  );
};

EmbeddedEvidenceForm.propTypes = {
  value: PropTypes.object,
  item: PropTypes.object,
  onChange: PropTypes.func,
  patrolEvidenceOptions: PropTypes.bool,
};

export default EmbeddedEvidenceForm;
